@if (mode === BookingMode.AlreadyBooked) {
    <div class="d-flex" style="max-width: 480px; margin: 0 auto;">
        <lib-empty-state
            [emptyStateGraphic]="EmptyStateGraphic.CalendarChangeEvent">
            <ng-container emptyStateText i18n="@@CommonBookingWidgetTimeSlotTakenTitle">Looks like that time's taken</ng-container>
            <ng-container emptyStateDescription i18n="@@CommonBookingWidgetTimeSlotTakenDescription">
                Unfortunately, this time slot is no longer available. Let's find an alternative that works for you.</ng-container>
            <ng-container emptyStateButton>
                <lib-button [role]="ButtonRole.Primary" (clicked)="FindNewSlot()">
                    <ng-container label i18n="@@CommonBookingWidgetTimeSlotTakenButtonLabel">Find a New Slot</ng-container>
                </lib-button>
            </ng-container>
        </lib-empty-state>
    </div>
} @else  {
    <div class="margin-top-16" [ngClass]="{'padding-x-32': !isMobile , 'padding-x-16': isMobile}">
        <div [ngClass]="{'design-building-block-sign-up-overlay' : isViewOnly}"></div>
        <lib-sign-up-slot-picker #slotPicker
            [formControl]="form.controls.Slot"
            [isViewOnly]="isViewOnly"
            [schoolID]="schoolID"
            [websiteBlockID]="websiteBlockID"
            [teachers]="teachers"
            [preFetchedSlots]="preFetchedSlots!"
            [existingEvents]="existingEvents"
            [eventCategoryIDs]="eventCategoryIDs"
            [advanceBookingLimitDays]="renderContext.SignupFormRenderContext?.AdvanceBookingLimitDays!"
            [allowTimezones]="renderContext.SignupFormRenderContext?.CanSetTimeZone! && signupStudentMode != SignupStudentMode.AdditionalStudent"
            [currentTimezone]="currentTimezone"
            (noSlotsAvailable)="NoSlotsAvailable($event)"
            (slotClicked)="BookAndSignup()">
        </lib-sign-up-slot-picker>
    </div>

    @if (mode !== BookingMode.NoSlots) {
        @if(signupStudentMode === SignupStudentMode.AdditionalStudent || stepper.currentStepPosition !== 0){
            <mat-divider class="mt-3 w-100"></mat-divider>
    
            <lib-submission-bar
                [kind]="SubmissionBarKind.WidgetStepper">    
                @if (stepper.currentStepPosition !== 0) {
                    <lib-button
                        [role]="ButtonRole.Secondary"
                        [kind]="ButtonKind.NeutralSecondary"
                        [disabled]="form.disabled || bookingClicked"
                        [isViewOnly]="isViewOnly"
                        [size]="ButtonSize.Large"
                        (clicked)="PreviousClicked()">
                        <ng-container label>
                            <ng-container i18n="@@CommonPreviousButton">Previous</ng-container>
                        </ng-container>
                    </lib-button>
                }
    
                @if (signupStudentMode === SignupStudentMode.AdditionalStudent) {
                    <lib-button
                    [role]="ButtonRole.Secondary"
                        [kind]="ButtonKind.NeutralSecondary"
                        [disabled]="form.disabled || bookingClicked"
                        [isViewOnly]="isViewOnly"
                        [size]="ButtonSize.Large"
                        (clicked)="CancelClicked()">
                        <ng-container label>
                            <ng-container i18n="@@CommonCancelButton">Cancel</ng-container>
                        </ng-container>
                    </lib-button>
                }
    
                <ng-template #customAction>
                    <p class="typography-label-large" i18n="@@CommonCurrentStepOfStepsLabel">{{currentStepIndex}} of {{totalStepCounts}}</p>
                </ng-template>
    
            </lib-submission-bar>
        } @else {
            <br />
        }
    }
}